"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Object$freeze;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-prototype-builtins */
// Code only touches objects with hardcoded keys. 

/**
 * This module exports a static `Environment` helper class used to select a runtime environment,
 * and then access the common environment variables for that respective environment.
 * 
 * @module Environment
 */
// environment keys
var LOCAL = 'local';
var DEVELOPMENT = 'development';
var STAGING = 'staging';
var PRODUCTION = 'production'; // environment values

var environments = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, LOCAL, {
  my_ifly_server: 'https://local-my.iflyworld.com',
  wordpress_server: 'https://www.iflyworld.com',
  api2cache_server: 'https://api2-cache.iflyworld.com',
  identity_server: 'https://stg-login.iflyworld.com',
  core_api_server: 'https://stg-coreapi.iflyworld.com'
}), _defineProperty(_Object$freeze, DEVELOPMENT, {
  my_ifly_server: 'https://dev-my.iflyworld.com',
  wordpress_server: 'https://dev1-www.iflyworld.com',
  api2cache_server: 'https://deva-api2-cache.iflyworld.com',
  identity_server: 'https://dev-login.iflyworld.com',
  core_api_server: 'https://dev-coreapi.iflyworld.com'
}), _defineProperty(_Object$freeze, STAGING, {
  my_ifly_server: 'https://stg-my.iflyworld.com',
  wordpress_server: 'https://stage-www.iflyworld.com',
  api2cache_server: 'https://stg-api2-cache.iflyworld.com',
  identity_server: 'https://stg-login.iflyworld.com',
  core_api_server: 'https://stg-coreapi.iflyworld.com'
}), _defineProperty(_Object$freeze, PRODUCTION, {
  my_ifly_server: 'https://my.iflyworld.com',
  wordpress_server: 'https://www.iflyworld.com',
  api2cache_server: 'https://api2-cache.iflyworld.com',
  identity_server: 'https://login.iflyworld.com',
  core_api_server: 'https://coreapi.iflyworld.com'
}), _Object$freeze)); // production is selected by default

var _selected = PRODUCTION;

var env = _objectSpread({}, environments[_selected]);

var Environment = /*#__PURE__*/function () {
  function Environment() {
    _classCallCheck(this, Environment);
  }

  _createClass(Environment, null, [{
    key: "select",

    /**
     * Selects the set of runtime environment values to emit for the given key.
     *
     * The `production` runtime environment is selected by default. Alternative
     * key values are `local`, `development`, or `staging`.
     *
     * Overrides or additional values may be passed as a second parametere.
     *
     * @example
     * // adds a new environment variable
     * Environment.select(APP_ENV, {
     *     [Environment.LOCAL]: {
     *         myServer: 'https://local-myserver.com'
     *     },
     *     [Environment.DEVELOPMENT]: {
     *         myServer: 'https://dev-myserver.com'
     *     },
     *     [Environment.STAGING]: {
     *         myServer: 'https://stg-myserver.com'
     *     },
     *     [Environment.PRODUCTION]: {
     *         myServer: 'https://myserver.com'
     *     }
     * );
     * console.log( Environment.getValue('myServer') ); 
     * 
     * @param {string} key The environment key
     * @param {object} overrides An optional map of overrides or additional values.
     * @return {object} A map of the currently selected environment values.
     */
    value: function select(key, overrides) {
      _selected = key || PRODUCTION;

      if (overrides === undefined) {
        overrides = {};
      } else {
        if (_selected === LOCAL || _selected === DEVELOPMENT) {
          checkEnvironmentSelect(key, overrides);
        }

        if (!overrides[_selected]) {
          overrides = {};
        }
      }

      env = deepFreeze(_objectSpread({}, environments[_selected], {}, overrides[_selected] || {}));
      return env;
    }
    /**
     * Gets the currently selected environment.
     * @return {string} one of `local`, `development`, `staging`, or `production`.
     */

  }, {
    key: "selected",
    value: function selected() {
      return _selected;
    }
    /**
     * Gets a map of all values for the currently selected environment.
     * @return {object} A map of environment values.
     */

  }, {
    key: "get",
    value: function get() {
      return env;
    }
    /**
     * Gets the currently selected environment value for the given key. Use
     * this method to resolve new key-values added during initialization.
     * @param {string} key The environment value to get.
     */

  }, {
    key: "getValue",
    value: function getValue(key) {
      return env[key];
    }
    /**
     * Returns true if the currently selected environment is `development`.
     * @return {boolean} `true` if development, and `false` otherwise
     */

  }, {
    key: "isDevelopment",
    value: function isDevelopment() {
      return _selected === LOCAL || _selected === DEVELOPMENT;
    }
    /**
     * Gets the PHP api cache server for the currently selected environment.
     * @return {string} The api2-cache.iflyworld.com server.
     */

  }, {
    key: "api2CacheServer",
    value: function api2CacheServer() {
      return env.api2cache_server;
    }
    /**
     * Gets the CoreAPI server for the currently selected environment.
     * @return {string} The coreapi.iflyworld.com server.
     */

  }, {
    key: "coreApiServer",
    value: function coreApiServer() {
      return env.core_api_server;
    }
    /**
     * Gets the identity server for the currently selected environment.
     * @return {string} The login.iflyworld.com server.
     */

  }, {
    key: "identityServer",
    value: function identityServer() {
      return env.identity_server;
    }
    /**
     * Gets the membership server for the currently selected environment.
     * @return {string} The my.iflyworld.com server.
     */

  }, {
    key: "myIflyServer",
    value: function myIflyServer() {
      return env.my_ifly_server;
    }
    /**
     * Gets the wordpress server for the currently selected environment.
     * @return {string} The www.iflyworld.com server.
     */

  }, {
    key: "wordPressServer",
    value: function wordPressServer() {
      return env.wordpress_server;
    }
  }]);

  return Environment;
}(); // deepfreeze an object so that it cannot be modified at any level


exports["default"] = Environment;
Environment.LOCAL = LOCAL;
Environment.DEVELOPMENT = DEVELOPMENT;
Environment.STAGING = STAGING;
Environment.PRODUCTION = PRODUCTION;

function deepFreeze(o) {
  Object.freeze(o);
  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop) && o[prop] !== null && (_typeof(o[prop]) === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  return o;
}

function checkEnvironmentSelect(key, overrides) {
  var overrideEnvironments = Object.entries(overrides).length,
      err;

  if (key !== LOCAL && key !== DEVELOPMENT && key !== STAGING && key !== PRODUCTION) {
    err = "Environment.select(key, overrides) --> passed unknown key \"".concat(key, "\". Expected \"local\", \"development\", \"staging\", or \"production\".");
  } else if (overrides === undefined || !overrideEnvironments) {
    return;
  } else if (!(overrides instanceof Object)) {
    err = "Environment.select(\"".concat(key, "\", overrides) --> overrides should be an object. Passed: ").concat(JSON.stringify(overrides));
  } else if (!overrides[LOCAL] || !overrides[DEVELOPMENT] || !overrides[STAGING] || !overrides[PRODUCTION] || 4 !== overrideEnvironments) {
    err = "Environment.select(\"".concat(key, "\", overrides) --> overrides must have exactly four environment keys: \"local\", \"development\", \"staging\", and \"production\". Passed: ").concat(JSON.stringify(overrides));
  } else {
    var localKeys = JSON.stringify(Object.keys(overrides[LOCAL]).sort()),
        devKeys = JSON.stringify(Object.keys(overrides[DEVELOPMENT]).sort()),
        stageKeys = JSON.stringify(Object.keys(overrides[STAGING]).sort()),
        prodKeys = JSON.stringify(Object.keys(overrides[PRODUCTION]).sort());

    if (localKeys === devKeys && devKeys === stageKeys && stageKeys === prodKeys) {
      return; // overrides passed symmetry check
    }

    err = "Environment.select(\"".concat(key, "\", overrides) --> overrides expects all environment values to have exactly the same keys. Passed: ").concat(JSON.stringify(overrides));
  }

  throw new Error(err);
}